<template>
    <div class="story full-h" ref="content">
        <div class="row full-h">
            <div class="column-center full-w">
                <slot name="header"></slot>
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Structure_NoTabs"
}
</script>